import {getCheckoutSummary, getTaxLabel} from '@wix/wix-events-commons-statics'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {EventText} from '../../../../../../commons/components/event-text'
import {useMembersPageCurrencyFormatter} from '../../../hooks/currency'
import {Divider} from '../../styled-components/divider'
import sc from '../common.scss'
import {Price} from '../price'
import {SubtotalsProps} from './interfaces'
import s from './subtotals.scss'

export const Subtotals = ({invoice}: SubtotalsProps) => {
  const {t} = useTranslation()
  const {getFormattedMoney} = useMembersPageCurrencyFormatter()
  const {subtotal, discount, tax, addedFee, total} = getCheckoutSummary(invoice, getFormattedMoney)
  const taxLabel = getTaxLabel(invoice)

  return (
    <>
      {subtotal && (
        <>
          <div className={sc.section} data-hook={DH.SUBTOTALS_CONTAINER}>
            <Price value={subtotal} label={t('mobile.order.subtotal')} dataHook={DH.SUBTOTAL} />
            <Price value={discount} label={t('mobile.order.coupon')} dataHook={DH.DISCOUNT_TOTAL} />
            <Price value={tax} label={taxLabel} dataHook={DH.TAX} />
            <Price value={addedFee} label={t('order.serviceFee')} />
          </div>
          <Divider />
        </>
      )}
      <div className={classNames(s.overallTotal, sc.splitRow)}>
        <EventText>{t('mobile.order.overall.total')}</EventText>
        <EventText>{total}</EventText>
      </div>
    </>
  )
}
